import React from 'react';
import AOSPOperations from "./components/AOSPOperations";
import Header from "./components/Header";
import Footer from "./components/footer";

const Home = () => {
    return (
        <div className="w-full p-6 h-screen flex flex-col">
            {/* Header Section */}
           <Header />

            {/* Hero Section */}
            <div className="bg-gradient-to-r mt-20 from-blue-500 to-teal-400 text-white p-8 rounded-lg shadow-lg">
                <h1 className="text-3xl md:text-5xl font-bold mb-4 text-center">African Open Science Platform
                    (AOSP)</h1>
                <p className="text-lg md:text-xl text-center">Node for the Eastern African Region</p>
            </div>

            {/* About Section */}
            <div className="container mx-auto grid grid-cols-1 xl:grid-cols-2 gap-6 mt-6">
                <div className="bg-white p-6 rounded-lg ">
                    <h2 className="text-2xl font-semibold mb-4">Welcome to AOSP-EA Node</h2>
                    <p className="text-gray-700 leading-7 mb-4">
                        The African Open Science Platform (AOSP) , node for the East African region is hosted by
                        the <span
                        className="font-bold">Institute for Capacity Development <a
                        href="https://www.aicad.or.ke/aosp/" className="text-blue-600">(AICAD)</a></span> in partnership
                    with <span
                               className="font-bold">Jomo Kenyatta University of Agriculture and Technology <a
                        href="https://www.jkuat.ac.ke/" className="text-blue-600">(JKUAT)</a></span>.
                    </p>
                    <p className="text-gray-700 leading-7 mb-4">
                        The National Research Foundation (NRF) of <a href="https://aosp.org.za/" target="_blank"
                                                                     className="text-blue-600 cursor-pointer">South
                        Africa</a> announced the appointment of an initial three regional nodes of the
                        African Open Science Platform. Awards were made following a competitive application process to
                        the Egyptian National Authority for Remote Sensing and Space Sciences (NARSS) for the Northern
                        African Node based in <a href="https://www.narss.sci.eg/" target="_blank"
                                                 className="text-blue-600 cursor-pointer"> Egypt</a>; the African
                        Institute for Capacity Development (AICAD) for the East
                        African Node based in Kenya, and to the UbuntuNet Alliance for the Southern Africa Node based in
                        <a
                            href="https://info-africarxiv.ubuntunet.net/2024/03/07/facilitating-the-implementation-of-open-science-practices-across-africa/" target="_blank"
                            className="text-blue-600 cursor-pointer"> Zambia</a>.
                    </p>
                    <p className="text-gray-700 leading-7 mb-4">
                        The platform aims to position African scientists at the cutting edge of data-intensive science
                        by stimulating interactivity and creating opportunities. This is achieved through:
                    </p>
                    <div className="flex flex-wrap gap-4">
                        <div
                            className="bg-white p-6 rounded-lg shadow-md w-full transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl cursor-pointer">
                            <h3 className="font-semibold text-lg text-gray-900">Developing efficiencies of scale</h3>
                        </div>
                        <div
                            className="bg-white p-6 rounded-lg shadow-md w-full transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl cursor-pointer">
                            <h3 className="font-semibold text-lg text-gray-900">Building critical mass through shared
                                capacities</h3>
                        </div>
                        <div
                            className="bg-white p-6 rounded-lg shadow-md w-full transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl cursor-pointer">
                            <h3 className="font-semibold text-lg text-gray-900">Amplifying impact through a commonality
                                of purpose and voice</h3>
                        </div>
                        <div
                            className="bg-white p-6 rounded-lg shadow-md w-full transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl cursor-pointer">
                            <h3 className="font-semibold text-lg text-gray-900">Engaging in a Global Commons to address
                                continental and global challenges through joint action</h3>
                        </div>
                    </div>


                </div>
                <div
                    className=" p-6  items-center justify-center">
                    <div className="w-full h-auto block">
                        <img
                            src="https://aospea.org/aicad.jpg" // Replace with your image URL
                            alt="Vision"
                            className="object-cover w-full h-full rounded-lg shadow-lg"
                        />
                    </div>
                    {/* Short description below the image */}
                    <p className="mt-4 text-center text-lg  italic text-gray-600">
                        AICAD buidling hosting AOSP EA Region Node
                    </p>
                </div>




            </div>

            <section className="bg-gray-50 py-16 px-6 lg:px-24">
                <div className="max-w-6xl mx-auto text-center">
                    <h2 className="text-4xl font-semibold text-gray-800 mb-8">
                        The Role of the AOSP
                    </h2>

                    <p className="text-lg text-gray-700 mb-12">
                        The AOSP (Open Science Programme) plays a vital role in coordinating, supporting, and
                        promoting Open Science initiatives at regional and global levels. By creating linkages and
                        strengthening knowledge networks, it enhances cooperation across regions while advancing the
                        implementation of Open Science goals.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
                        <div className="bg-white shadow-lg rounded-lg p-8 text-center">
                            <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                                Programme Delivery & Implementation
                            </h3>
                            <p className="text-gray-600">
                                AOSP leads in the delivery and execution of Open Science programmes, ensuring
                                alignment with regional and global objectives.
                            </p>
                        </div>

                        <div className="bg-white shadow-lg rounded-lg p-8 text-center">
                            <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                                Capacity Building & Societal Engagement
                            </h3>
                            <p className="text-gray-600">
                                Focuses on capacity building and fostering societal dialogue to drive awareness
                                and participation in Open Science initiatives.
                            </p>
                        </div>

                        <div className="bg-white shadow-lg rounded-lg p-8 text-center">
                            <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                                Policy Support & UNESCO Recommendations
                            </h3>
                            <p className="text-gray-600">
                                Provides policy support and actively promotes the UNESCO Open Science
                                Recommendations at both national and regional levels.
                            </p>
                        </div>
                    </div>

                    <div className="mt-12">
                        <p className="text-lg text-gray-700">
                            The AOSP serves as a catalyst for the realization of Open Science at all levels,
                            strengthening cooperation and ensuring long-term sustainability through inclusive, regional,
                            and global collaboration.
                        </p>
                    </div>
                </div>
            </section>

            <section className="bg-white py-16 px-6 lg:px-24">
                <div className="max-w-6xl mx-auto text-center">
                    <h2 className="text-4xl font-semibold text-gray-800 mb-8">
                        The Vision & Goals of the AOSP
                    </h2>

                    <p className="text-lg text-gray-700 mb-12">
                        The AOSP aims to position African scientists at the forefront of data-intensive science
                        by fostering interactivity and creating opportunities. It builds efficiencies of scale,
                        amplifies impact through a shared purpose and voice, and engages in global efforts to
                        address continental and global challenges.
                    </p>

                    <div className="mb-12 text-left">
                        <h3 className="text-3xl font-semibold text-gray-800 mb-4">
                            The AOSP enables collective planning and practice to:
                        </h3>

                        <ul className="space-y-6 text-lg text-gray-700">
                            <li className="flex items-start">
                                <svg
                                    className="w-6 h-6 text-blue-500 mr-4 mt-1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>
                                <span>Drive alignment, collaboration, and cooperation between existing initiatives.</span>
                            </li>
                            <li className="flex items-start">
                                <svg
                                    className="w-6 h-6 text-blue-500 mr-4 mt-1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>
                                <span>Identify critical gaps and set priorities for action.</span>
                            </li>
                            <li className="flex items-start">
                                <svg
                                    className="w-6 h-6 text-blue-500 mr-4 mt-1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>
                                <span>Design and deliver activities to respond to those gaps and priorities.</span>
                            </li>
                            <li className="flex items-start">
                                <svg
                                    className="w-6 h-6 text-blue-500 mr-4 mt-1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>
                                <span>Mobilize existing resources and initiate new projects in pursuit of the Platform’s aims.</span>
                            </li>
                            <li className="flex items-start">
                                <svg
                                    className="w-6 h-6 text-blue-500 mr-4 mt-1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>
                                <span>Enhance communication, outreach, and advocacy efforts.</span>
                            </li>
                        </ul>
                    </div>

                    <p className="text-lg text-gray-700">
                        Through these efforts, the AOSP is shaping a future of collective action and impactful
                        collaboration that addresses both continental and global challenges, while fostering
                        sustainable solutions for data-intensive science.
                    </p>
                </div>
            </section>
            <AOSPOperations/>
            {/* Footer */}
            {/*<footer className="text-center mt-6 text-gray-600">*/}
            {/*    <p>&copy; 2024 African Open Science Platform - Eastern African Node</p>*/}
            {/*</footer>*/}
            <Footer/>
        </div>
    );
};

export default Home;
